import * as React from 'react'
import { CreateNewProps } from './typings'
import { useActions, useCreateNewStyles } from './hooks'
import { CreateNewLocationCard } from './CreateNewLocationCard'
import { Masonry } from '@sales-center/components'
import { useLocationCardsState } from '../../hooks'

import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

export const CreateNew: React.FC<CreateNewProps> = (props) => {
  const { billToLocations, serviceLocations } = props
  const { styles, gutter } = useCreateNewStyles()

  const { saving } = useActions(props)

  const openState = useLocationCardsState()

  return (
    <>
      <Box sx={styles.container}>
        <Typography sx={styles.header}>Create New Location</Typography>
        <Typography>
          The following Locations will be created upon saving
        </Typography>

        <Box display="flex">
          <Box sx={styles.billTo}>
            <CreateNewLocationCard
              {...props}
              {...openState}
              disableEdit={saving}
              location={billToLocations[0]}
            />
          </Box>

          <Masonry sx={styles.masonry} itemWidth={320} gutter={gutter}>
            {serviceLocations.map((l) => (
              <CreateNewLocationCard
                {...props}
                {...openState}
                key={l.id}
                location={l}
                disableEdit={saving}
              />
            ))}
          </Masonry>
        </Box>
      </Box>
    </>
  )
}
CreateNew.displayName = 'CreateNew'
